export enum EditVehiculeCheckTypeTab {
  INFOS = 'infos',
  CHECK_POINTS = 'checkPoints',
}
